<template>
  <div class="phone-header">
    <el-avatar
      class="phone-header__avatar"
      :size="100"
      :src="avatar"
    />
    <div
      v-if="data.header.find(i => i.type === 'header_tags_widget')"
      class="phone-header__tags"
    >
      {{ translateText('hubstr.editor.phone_preview.view_content.team') }}
    </div>
    <h1
      class="phone-header__name_widget"
    >
      {{ translateText('hubstr.editor.phone_preview.view_content.name') }}
      <component v-if="status" :is="Crown"/>
    </h1>
    <div
      v-if="data.header.find(i => i.type === 'header_badge_widget')"
      class="phone-header__badge"
    >
      {{ data.header.find((i) => i.type === 'header_badge_widget').label || translateText('hubstr.editor.phone_preview.view_content.badge') }}
    </div>
  </div>
  <div class="phone-header__action-buttons">
    <ActionButtons :data="data.header" />
  </div>

  <div
    v-for="view in data.body"
    :key="view"
    class="phone-body"
  >
    <h3
      class="phone-body__title"
    >
      {{ TranslatesList[view.title.replace('lang.', '')] || view.title }}
    </h3>
    <br>
    <template v-if="view.type === GROUP_TYPES.SOCIAL">
      <SocialButtons :data="view" />
    </template>
    <template v-else>
      <div
        v-for="field in view.widgets"
        :key="field.title"
      >
        <component
          :is="TYPE_FIELDS_TO_COMPONENTS[field.type]"
          :key="field.title"
          :data="field"
        />
      </div>
    </template>
  </div>
  <div class="phone-footer">
    <div
      v-if="data.footer.some((i) => i.type === 'entry_widget')"
      class="phone-footer__member"
    >
      {{ translateText('hubstr.editor.main.footer.member_since') }}
    </div>
    <div
      v-if="data.footer.some((i) => i.type === 'form_group_widget')"
      class="phone-footer__form-group"
    >
      {{ translateText('hubstr.editor.main.footer.forum_group') }}
    </div>
  </div>
  <br>
  <br>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { Header, Widgets, Body } from 'features/settings/mobile-editor/interfaces';
import ActionButtons from 'features/settings/mobile-editor/components/right-side/components/action-buttons.vue';
import SocialButtons from 'features/settings/mobile-editor/components/right-side/components/social-buttons.vue';
import TextSection from 'features/settings/mobile-editor/components/right-side/components/fields/phone-view-content/text-section.vue';
import CompanyList from 'features/settings/mobile-editor/components/right-side/components/fields/phone-view-content/company-list.vue';
import ListLine from 'features/settings/mobile-editor/components/right-side/components/fields/phone-view-content/list-line.vue';
import InfoLineAction
  from 'features/settings/mobile-editor/components/right-side/components/fields/phone-view-content/info-line-action.vue';
import ListLineRawAction
  from 'features/settings/mobile-editor/components/right-side/components/fields/phone-view-content/list-line-raw-action.vue';
import Entry from 'features/settings/mobile-editor/components/right-side/components/fields/phone-view-content/entry.vue';
import { GROUP_TYPES, TYPE_FIELDS_TO_COMPONENTS } from 'features/settings/mobile-editor/constants';
import { AdditionsList, TranslatesList } from 'features/settings/mobile-editor/requests';
import { translate, useTranslate } from 'magner';
import Crown from 'features/settings/mobile-editor/components/right-side/assets/icons/crown.svg';

export default defineComponent({
  name: 'PhoneViewContent',
  components: {
    ActionButtons,
    SocialButtons,
    TextSection,
    CompanyList,
    ListLine,
    InfoLineAction,
    ListLineRawAction,
    Entry,
  },
  props: {
    data: {
      type: Object as PropType<Widgets>,
      required: true,
    },
  },
  setup (props) {
    const { customT } = useTranslate();
    const translateText = (code: string) => customT(translate(code));

    const avatar = props.data.header.find((i: Header) => i.type === 'header_avatar_widget')?.value || '';
    const status = props.data.header.find((i: Header) => i.type === 'header_title_with_icon_widget');

    return {
      avatar,
      status,
      translateText,

      TYPE_FIELDS_TO_COMPONENTS,
      Crown,
    };
  },
  computed: {
    TranslatesList () {
      return TranslatesList;
    },
    GROUP_TYPES () {
      return GROUP_TYPES;
    },
    AdditionsList () {
      return AdditionsList;
    },
  },
});
</script>

<style lang="scss" scoped>
.phone-header {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__name {
    margin-bottom: 0;
    font-weight: 300;
    font-size: 26px;
    text-align: center;
  }
  &__tags {
    font-size: 10px;
    margin-top: 15px;
    color: var(--el-color-warning);
  }
  &__avatar {
    position: relative;
  }
  &__badge {
    color: var(--el-text-color-secondary);
    font-size: 10px;
    margin-top: 5px;
  }
  &__action-buttons {
    padding: 0 10px;
  }
}

.phone-body {
  &__title {
    font-size: 20px;
    font-weight: 400;
    padding-bottom: 10px;
  }
}

.phone-footer {
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 10px;
  margin-top: 10px;

  &__member {
    color: var(--el-text-color-disabled);
  }
  &__form-group {
    color: var(--el-color-primary);
  }
}
</style>
